// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Types$RescriptReactIntro from "./Types.bs.js";

function s(prim) {
  return prim;
}

function CompHeader(Props) {
  var comp = Props.comp;
  var nominals = Props.nominals;
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "container"
                }, React.createElement("div", {
                      className: "tile is-ancestor",
                      wrap: ""
                    }, React.createElement("div", {
                          className: "tile"
                        }, React.createElement("div", {
                              className: "tile is-parent"
                            }, React.createElement("div", {
                                  className: "tile is-child box"
                                }, React.createElement("p", {
                                      className: "title is-3"
                                    }, comp.compName), React.createElement("p", {
                                      className: "title is-5"
                                    }, Types$RescriptReactIntro.compSlug(comp)), React.createElement("div", {
                                      className: "example"
                                    }, React.createElement("div", {
                                          className: "field is-grouped is-grouped-multiline"
                                        }, React.createElement("div", {
                                              className: "control"
                                            }, React.createElement("div", {
                                                  className: "tags has-addons"
                                                }, React.createElement("span", {
                                                      className: "tag"
                                                    }, "UTC offset"), React.createElement("span", {
                                                      className: "tag is-warning"
                                                    }, String(comp.utcOffset.timeZoneMinutes)))), React.createElement("div", {
                                              className: "control"
                                            }, React.createElement("div", {
                                                  className: "tags has-addons"
                                                }, React.createElement("span", {
                                                      className: "tag"
                                                    }, "minimum distance"), React.createElement("span", {
                                                      className: "tag is-black"
                                                    }, nominals.free))), React.createElement("div", {
                                              className: "control"
                                            }, React.createElement("div", {
                                                  className: "tags has-addons"
                                                }, React.createElement("span", {
                                                      className: "tag"
                                                    }, "nominal distance"), React.createElement("span", {
                                                      className: "tag is-info"
                                                    }, nominals.distance))), React.createElement("div", {
                                              className: "control"
                                            }, React.createElement("div", {
                                                  className: "tags has-addons"
                                                }, React.createElement("span", {
                                                      className: "tag"
                                                    }, "nominal time"), React.createElement("span", {
                                                      className: "tag is-success"
                                                    }, nominals.time))), React.createElement("div", {
                                              className: "control"
                                            }, React.createElement("div", {
                                                  className: "tags has-addons"
                                                }, React.createElement("span", {
                                                      className: "tag"
                                                    }, "nominal goal"), React.createElement("span", {
                                                      className: "tag is-primary"
                                                    }, String(nominals.goal)))), React.createElement("div", {
                                              className: "control"
                                            }, React.createElement("div", {
                                                  className: "tags has-addons"
                                                }, React.createElement("span", {
                                                      className: "tag"
                                                    }, "score-back time"), React.createElement("span", {
                                                      className: "tag is-danger"
                                                    }, Belt_Option.getWithDefault(comp.scoreBack, ""))))))))))));
}

var make = CompHeader;

export {
  s ,
  make ,
  
}
/* react Not a pure module */
